/**
 * Copyright 2016-2021 Sourcepole AG
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import SideBar from 'qwc2/components/SideBar';
import LocaleUtils from 'qwc2/utils/LocaleUtils';
import LayerFilters from "../components/LayerFilters";
import '../style/Indicators.css';

class LayerFilter extends React.Component {
    static propTypes = {
        currentTask: PropTypes.object,
        layerFilters: PropTypes.array,
        side: PropTypes.string,
        width: PropTypes.string
    }
    static defaultProps = {
        width: "25em",
        side: 'right'
    }
    state = {
        filter: "",
        sidebarwidth: null
    }

    render() {
        let layerFilters = (
            <div>Es sind keine Filter definiert.</div>
        );
        if (this.props.layerFilters.length > 0) {
            layerFilters = (
                <div className="layertree-option layertree-option-layerfilters">
                    <LayerFilters />
                </div>
            );
        }

        return (
            <div>
                <SideBar icon="filter" id="LayerFilter"
                         side={this.props.side}
                         title={LocaleUtils.tr("appmenu.items.LayerTree")} width={this.state.sidebarwidth || this.props.width}>
                    {() => ({
                        body: (
                            <div>
                                {layerFilters}
                            </div>
                        )
                    })}
                </SideBar>
            </div>
        );
    }
}

const selector = (state) => ({
    layerFilters: state.layers.filters
});

export default connect(selector, {

})(LayerFilter);
